// extracted by mini-css-extract-plugin
export default {"headline":"Headline_headline__AF2dI","h1":"Headline_h1__Mbt89","MoveUp":"Headline_MoveUp__lhomv","description":"Headline_description__RySAh","Show":"Headline_Show__HA5MZ"};